import { useQuery } from "react-query";
import { checkIfItIsVideoSrc } from "utils/helpers.adEngine";

export const useCheckIfItIsVideoSrc = (videoSrc: string) => {
  return useQuery(["checkIfItIsVideoSrc", videoSrc], async () => {
    const { isVideo, src } = await checkIfItIsVideoSrc(videoSrc);
    return { isVideo, src };
  });
};
